/**
 * Calendar Constants
 * Shared constants for calendar components
 */

import { MealTypeConfig, DayOfWeek } from '@talktoast/shared'

/**
 * Days of the week configuration
 */
export const DAYS_OF_WEEK: DayOfWeek[] = [
  { key: 'sunday', label: 'Sun', fullLabel: 'Sunday' },
  { key: 'monday', label: 'Mon', fullLabel: 'Monday' },
  { key: 'tuesday', label: 'Tue', fullLabel: 'Tuesday' },
  { key: 'wednesday', label: 'Wed', fullLabel: 'Wednesday' },
  { key: 'thursday', label: 'Thu', fullLabel: 'Thursday' },
  { key: 'friday', label: 'Fri', fullLabel: 'Friday' },
  { key: 'saturday', label: 'Sat', fullLabel: 'Saturday' }
]

/**
 * Meal types with UI metadata
 */
export const MEAL_TYPES: MealTypeConfig[] = [
  { key: 'breakfast', label: 'Breakfast', emoji: '🌅', color: 'yellow' },
  { key: 'lunch', label: 'Lunch', emoji: '☀️', color: 'orange' },
  { key: 'dinner', label: 'Dinner', emoji: '🌙', color: 'blue' },
  { key: 'snacks', label: 'Snacks', emoji: '🍎', color: 'green' },
  { key: 'dessert', label: 'Dessert', emoji: '🍰', color: 'pink' }
]

/**
 * Get meal type color classes for Tailwind
 */
export function getMealTypeColorClasses(color: string): {
  bg: string
  text: string
  border: string
  hover: string
} {
  const colorMap: Record<string, { bg: string; text: string; border: string; hover: string }> = {
    yellow: {
      bg: 'bg-yellow-50',
      text: 'text-yellow-700',
      border: 'border-yellow-200',
      hover: 'hover:bg-yellow-100'
    },
    orange: {
      bg: 'bg-orange-50',
      text: 'text-orange-700',
      border: 'border-orange-200',
      hover: 'hover:bg-orange-100'
    },
    blue: {
      bg: 'bg-blue-50',
      text: 'text-blue-700',
      border: 'border-blue-200',
      hover: 'hover:bg-blue-100'
    },
    green: {
      bg: 'bg-green-50',
      text: 'text-green-700',
      border: 'border-green-200',
      hover: 'hover:bg-green-100'
    },
    pink: {
      bg: 'bg-pink-50',
      text: 'text-pink-700',
      border: 'border-pink-200',
      hover: 'hover:bg-pink-100'
    }
  }

  return colorMap[color] || colorMap.blue
}

/**
 * Get meal type configuration by key
 */
export function getMealTypeConfig(mealType: string): MealTypeConfig | undefined {
  return MEAL_TYPES.find(mt => mt.key === mealType)
}
